import { schema } from "normalizr";
import { PageLinkSchema } from "./page-link";

export const PageLinksSchema = new schema.Array(PageLinkSchema);
